import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Box, Container, Flex, Spinner } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import NavBar from 'Components/element/NavBar';
import Sidebar from 'Components/employersSide/Sidebar';
import Footer from 'Components/element/Footer';

import { useUserContext } from 'user';
import { JobForm } from 'jobs/job-form';

import { useRootStore } from 'core/hooks/use-root-store';
import { useCreateJob } from './create-job.provider';
import { NoPlanDialog } from './no-plan-dialog';
import './create-job.scss';

export function CreateJobView() {
   const navigate = useNavigate();
   const rootStore = useRootStore();
   const store = useCreateJob();
   const { user } = useUserContext();
   const [ready, setReady] = React.useState(false);

   React.useEffect(() => {
      store.jobManager.fetchAttributtes({
         onPlanError: (error) => {
            rootStore.globalDialog.open(<NoPlanDialog message={error} />, {
               minWidth: '450px',
               maxWidth: '450px',
            });
            navigate('/plans/purchase');
         },
         onSuccess: () => {
            setReady(true);
         },
      });
   }, [store]);

   return (
      <>
         <Container px="5" mb="6" mt="3%">
            <Flex width="100%" direction={{ initial: 'column', lg: 'row' }}>
               <Box>
                  <Sidebar />
               </Box>
               <Flex className="job-create__content" width="100%">
                  {ready ? (
                     <JobForm
                        heading="Створення вакансії"
                        jobManager={store.jobManager}
                        onJobCreate={(res) => {
                           if (res.status === 403) {
                              toast.error(res.message);
                           }

                           if (res.status === 500) {
                              toast.error(res.message);
                           }

                           if (res.status === 200) {
                              toast.success('Вакансію створено успішно');
                              navigate('/user/managejob');
                           }
                        }}
                        onCreateError={(error) => {
                           console.error('Feature create job error');
                           if (error.status === 400) {
                              navigate('/');
                           }
                        }}
                     />
                  ) : (
                     <Flex className="loader-overlay">
                        <Spinner size="3" />
                     </Flex>
                  )}
               </Flex>
            </Flex>
         </Container>
      </>
   );
}

export const CreateJob = observer(CreateJobView);
